import gql from 'graphql-tag';
import {ScheduledFlightFragment} from '../../../../../Queries/Scheduling';

/** Existing details mutation; changed-field payloads preserve unrelated route fields. */
export const UPDATE_FLIGHT_FORM = gql`
    mutation UpdateFlightForm($payload: FlightNodeInput!, $orgID: ID!) {
        setFlight: editFlight(input: {action: UPDATE_DETAILS, patch: $payload}, orgID: $orgID) {
            ...ScheduledFlightFragment
            weatherDelayTs
        }
    }
    ${ScheduledFlightFragment}
`;
